import { Component } from '@angular/core';
import { clientes } from '../../models/clientes';
import { Storage } from '@ionic/storage'
import { ClientesProvider } from '../../providers/clientes/clientes';
import { UtilsProvider } from '../../providers/utils/utils';
import { CajaProvider } from '../../providers/caja/caja';
import { NUBE_AWS } from '../../config/url.servicio';
import { Clienteselect } from '../../models/clienteselect/clienteselect.models';
import * as fromClienteSelectAll from '../../pages/meseromesero/state/clienteselect/clienteselect.accions'
import { Store } from '@ngrx/store';
import { AppState } from '../../pages/app.reducer';

@Component({
  selector: 'gestioncliente',
  templateUrl: 'gestioncliente.html'
})
export class GestionclienteComponent {

  direccionClienteRapido: string = ""
  telefonoClienteRapido: string = ""
  nombreClienteRapido: string = ""
  segId: string = 'gestionclientes'
  estadoFormCrearCliente: boolean = false
  clientesSelect = [];
  listaClientes = [];
  constructor(      public storage: Storage, public providerClientes: ClientesProvider,
    public utilsMensajero:UtilsProvider,
    public servicio: CajaProvider,
    private store: Store<AppState>,) {
  }

  guardarClienteRapido(){

    let datosCliente: clientes = {
      tipoIdentificacion : 'C',
      identificacion : '0',
      digito : '0',
      fechaExpedicion : '',
      primerApellido : '',
      numeroTelefono : this.telefonoClienteRapido,
      segundoApellido : '',
      primerNombre : this.nombreClienteRapido,
      segundoNombre : '',
      nombreCompleto : this.nombreClienteRapido,
      fechaIngreso : '',
      estado : 'A',
      direccion : this.direccionClienteRapido,
      queHago: "I",
      nombreTabla: "clientes",
      name: "dataDynamicCrud"
    }
    this.storage.get('companiasId').then((val) => {
      datosCliente['companiasId']  = val
    this.providerClientes.guardar(datosCliente)
      .subscribe(
      res => {
        this.utilsMensajero.mensajeMuestro('CLIENTES','Guardado Exitosamente!','success')
        this.limpiarClienteRapido()
        this.buscarClientes()
        this.segId = 'products'
      },
      err => {
        console.log(err)}
      )
    })

  }

  segmentChanged(event) {
    this.segId = event._value
  }

  limpiarClienteRapido(){

    this.telefonoClienteRapido = ""
    this.nombreClienteRapido = ""
    this.direccionClienteRapido = ""
    this.estadoFormCrearCliente = false

  }

  ionViewWillLeave() {
    this.buscarClientes();
    }
    buscarClientes() {
      this.storage.get('companiasId').then((val) => {
         this.servicio.buscarClientesAll(val)
        .subscribe((data: any)=> {
          let clienteJson = NUBE_AWS ? JSON.parse(data['_body']) : data[0]
          let clienteResponse = NUBE_AWS ? clienteJson.data[0] : data[0]
          this.clientesSelect = clienteResponse
          this.listaClientes = clienteResponse
          let cliente: Clienteselect[] = clienteResponse
          const actionClienteSelect = new fromClienteSelectAll.SetClienteselectAction(cliente);
          this.store.dispatch(new fromClienteSelectAll.UnsetClienteselectAction())
          this.store.dispatch(actionClienteSelect);
        },
         error=> {
           console.log(error);
         })
        });
    }



}



// WEBPACK FOOTER //
// ./src/components/gestioncliente/gestioncliente.ts